module.exports = __webpack_public_path__ + "0a9fd5178446171ed0dcbeb0da772beb.MP3";